/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Organizer from "./organizer"
import Footer from "./footer"
import Nav from "./nav"
import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      allPreviousYearsJson {
        nodes {
          year
          link
        }
      }
      contactInfoJson {
        email {
          label,
          link
        }
        twitterHandle {
          label,
          link
        }
      }
    }
  `)

  return (
    <>
      <Nav />
      <main>{children}</main>
      <Organizer />
      <Footer previousYears={data.allPreviousYearsJson.nodes} contactInfo={data.contactInfoJson} />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
